export enum LoginState {
  LOGIN_STATE_UNKNOWN = 'LOGIN_STATE_UNKNOWN',
  LOGIN_OK = 'LOGIN_OK',
  ISSUED_LOGIN_CODE = 'ISSUED_LOGIN_CODE',
  MFA_REQUIRED = 'MFA_REQUIRED',
  SIGN_UP_REQUIRED = 'SIGN_UP_REQUIRED',
  SOCIAL_LOGIN_PASSWORD_REQUIRED = 'SOCIAL_LOGIN_PASSWORD_REQUIRED',
  MFA_METHOD_SELECTION_REQUIRED = 'MFA_METHOD_SELECTION_REQUIRED',
  /**
   * login code issued by system (e.g. after 3 failed password attempts)
   */
  ISSUED_AUTOMATIC_LOGIN_CODE = 'ISSUED_AUTOMATIC_LOGIN_CODE',
}
